export class SchemalaggningListTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        namn: "Namn",
        start: "Start",
        slut: "Slut",
        senasteStatus: "Senaste status",
        senastStart: "Senaste start",
        senastSlut: "Senast slut",
        senastResultat: "Senaste resultat",
        resultat: "Resultat",
        status: "Status",
        senastvaraktighet: "Senast varaktighet",
        varaktighet: "Varaktighet",
        schemalagg: "Schemalägg",
        schemalaggDialogHead: "Schemalägga?",
        schemalaggDialogPromt: "Är du säker på att du vill schemalägga",
        schemalaggConfirm: "Schemaläggning slutförd",
        modalheader: "Historik för",
        runjobbagain: "FörsökIgen",
        setJobbToIgnore: "Ignorera",
        triggajobbheader: "Trigga jobb som ligger i Fel-kön"
    };
}
